import type { MovementError } from "@features/vessel-call/vessel-call-status/MovementServices/form/utils.ts";
import { updateResource as updateResourceService } from "@services/movementServicesApi";
import { useMutation } from "@tanstack/react-query";
import { runTransaction } from "@telemetry/runTransaction";

export const useEditResource = ({
  handleSuccess,
  handleError,
}: {
  handleSuccess: () => void;
  handleError: (error: MovementError) => void;
}) => {
  const updateResourceMutation = useMutation({
    mutationFn: (variables: Parameters<typeof updateResourceService>[0]) =>
      runTransaction(
        {
          module: "vessel_call",
          screen: "MovementService",
          action: "edit_resource",
          entityType: "movement_service",
        },
        (transactionId) =>
          updateResourceService({
            ...variables,
            ...(transactionId ? { transactionId } : {}),
          }),
      ),
    onSuccess: () => handleSuccess(),
    onError: (error: MovementError) => handleError(error),
  });

  const editResource = async (variables: Parameters<typeof updateResourceService>[0]) => {
    updateResourceMutation.mutate(variables);
  };

  return {
    editResource,
  };
};
